/**
 * TrustGate Loading Spinner Component
 * 
 * Provides consistent loading spinner animation
 * across all TrustGate console pages and components.
 */

import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  message?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md',
  className = "",
  message
}) => {
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-12 w-12', 
    lg: 'h-16 w-16'
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div className={`animate-spin rounded-full ${sizeClasses[size]} border-b-2 border-[#00d4aa]`} />
      {message && (
        <p className="text-[#cbd5e1] mt-4 text-center">{message}</p>
      )}
    </div>
  );
};
